module.exports = __webpack_public_path__ + "img/iconos-05.cd092f0f.png";